import { useEffect } from "react";
import GLightbox from "glightbox";
import data from "../data/banner.json";
// import Chapbook from "../../public/assets/images/rebecca/covers/chapbook.jpg";

// NOTE: Up to figuring out the import path for the image, setting it to the left side of the banner and the text to the right side. Needs a horizontal list with buttons too

const Banner = () => {
    const { banner } = data;
    const { image } = banner.bannerData[0];
    useEffect(() => {
        console.log(`jimmy - Banner data: `, banner.bannerData[0].image);
        GLightbox({
            selector: ".glightbox3",
        });
    }, []);
    return (
        <>
            <div className="banner">
                <div className="row">
                    <div className="">
                        <div className="section-title-center text-center aboutTitle">
                            <span>Now Available!</span>
                            <div className="section-divider divider-traingle"></div>
                        </div>
                    </div>
                </div>

                {/* Content section */}

                <div
                    className="container"
                    data-aos="fade-left"
                    data-aos-duration="1000"
                    data-aos-delay="200"
                >
                    <div className="side1">
                        <div className="imageContainer">
                            <img
                                src={image}
                                alt="The cover for The Poem Is You: Meditations on the art of matrescence, the new chapbook by Rebecca Diem"
                            />
                        </div>
                    </div>
                    <div className="side2">
                        <p>
                            <span>
                                The Poem Is You: Meditations on the Art of
                                Matrescence{" "}
                            </span>
                            is a poetry chapbook tracing the transformation of
                            becoming a mother — from the first ultrasound
                            heartbeat through the fog of early postpartum, the
                            grief of leaving a city, and the unexpected joy of
                            mom friendships forged at library storytimes and
                            physio appointments. Illustrated with personal
                            photographs, Diem writes with warmth, wit, and
                            unflinching honesty about the identity shift that no
                            one quite prepares you for.
                        </p>
                        <p>
                            <span>
                                Limited first edition of 100 copies with
                                epigraph by Mary Oliver. 32pp, full colour.
                                Printed in Owen Sound, ON. Woolf Like Me
                                Publishing.
                            </span>
                        </p>
                    </div>
                </div>
                <div className="storeLinks">
                    {/* <ul>
                        <a href="">
                            <li className="storeBtn">
                                <p>Shop Print Edition</p>
                            </li>
                        </a>
                        <a href="">
                            <li className="storeBtn">
                                <p>Shop eBook</p>
                            </li>
                        </a>
                        <a href="">
                            <li className="storeBtn">
                                <p>Information for Retailers</p>
                            </li>
                        </a>
                    </ul> */}
                    {/* <div className="storeBtn">
                        <a href="https://rebeccadiem.square.site/">
                            <p>Buy Now</p>
                        </a>
                    </div> */}
                </div>
            </div>
        </>
    );
};
export default Banner;
